module.exports = __webpack_public_path__ + "img/xmtz.93fdb3b0.png";